import UsersIndex from './Index';

export default function ClientsIndex() {

  return(
    <UsersIndex role="client" />
  )
}
